<template>
  <div id="Content">
    <Information/>
    <div class="container">
      <div class="row">
        <div class="nr-konfiguracji">
          <span>{{$t('message.keyGen')}}: <b style="color: rgb(80, 150, 199)">{{outputs.keyGen.value}}</b></span>
        </div>
        <!-- <button class="iconClear" @click="clear_clusters()">
          <img src="../assets/icon_clear.png" class="imgClear" :class="[tab == 'urzadzenia' ? 'active' : '']" title="wyczyść ustawienia"/>
        </button> -->
        <div class="col-sm kolumna kolumna-1">
          <div>
            <div class="list">
              <md-list :md-expand-single="false">
                <md-list-item md-expand>
                  <span class="md-list-item-text">{{$t('message.input_data')}}</span>
                  <md-list slot="md-expand">
                    <DaneWejsciowe/>
                  </md-list>
                </md-list-item>

                <md-list-item md-expand>
                  <span class="md-list-item-text">{{$t('message.devices')}}</span>
                  <md-list slot="md-expand">
                    <Urzadzenia/>
                  </md-list>
                </md-list-item>

                <md-list-item md-expand>
                  <span class="md-list-item-text">{{$t('message.accessories')}}</span>
                  <md-list slot="md-expand">
                    <Akcesoria/>
                  </md-list>
                </md-list-item>

                <md-list-item md-expand>
                  <span class="md-list-item-text">{{$t('message.results')}}</span>
                  <md-list slot="md-expand">
                    <Results/>
                  </md-list>
                </md-list-item>
                <!-- <div style="text-align:left">
                  Do testów: <br>
                  szafa: {{outputs.cena.szafa}} <br>
                  akumulatory: {{outputs.cena.akumulatory}} <br>
                  listwaD: {{outputs.cena.listwaD}} <br>
                  listwaZ: {{outputs.cena.listwaZ}} <br>
                  panelS: {{outputs.cena.panelS}} <br>
                  panelW: {{outputs.cena.panelW}} <br>
                  polka: {{outputs.cena.polka}} <br>
                  kolka: {{outputs.cena.kolka}} <br>
                  obudowa_dsos24: {{outputs.cena.obudowa_dsos24}} <br>
                  obudowa_plytki: {{outputs.cena.obudowa_plytki}} <br>
                  inne: {{outputs.cena.inne}} <br>
                  total: {{outputs.cena.total}} <br>
                </div> -->
              </md-list>
            </div>

            <div style="width:100%; text-align:right;">
              <button class="btn btnResult" @click="showDialogPodsumowanie = !showDialogPodsumowanie, showSidepanel = false">{{$t('message.results')}}</button>
            </div>

            <div id="info-place">
              <ul>
                <li style="margin-bottom: 15px;" v-html="$t('message.info_o_zamowieniu')"></li>
                <li style="" v-html="$t('message.trans')"></li>
              </ul>
            </div>
            <!-- <div class="control">
              <md-switch v-model="expandSingle">Expand Only One</md-switch>
              <md-checkbox v-model="expandNews">Expand News</md-checkbox>
            </div> -->

            <!-- <h4>
              <div><button @click="changeTab('dane')" :class="[tab == 'dane' ? 'active' : '']">Dane wejściowe</button></div>
              <div id="kreska"></div>
              <div>
                <button @click="changeTab('urzadzenia')" :class="[tab == 'urzadzenia' ? 'active' : '']">{{ $t("message.devices") }}</button>
                <button style="float: right; background: none; border: none; color: white; cursor: pointer;" @click="clear_clusters()">
                  <img src="../assets/icon_clear.svg" class="imgClear" style="width: 21px" :class="[tab == 'urzadzenia' ? 'active' : '']" title="wyczyść ustawienia"/>
                </button>
              </div>
            </h4>
            <div v-show="tab == 'dane'"><DaneWejsciowe/></div>
            <div v-show="tab == 'urzadzenia'"><Urzadzenia/></div> -->
          </div>
        </div> <!-- col-sm kolumna kolumna-1 -->
        <div class="col-sm">
          <div style="height: 720px; position: relative; width: 100%;">
          <Wizualizacja/>
          </div>
          <div id="panelCena" v-if="$i18n.locale === 'pl'">
            <p id="cena_netto">Cena netto systemu: <span>{{Math.ceil(cena)}}<em style="font-size: 22px;">PLN</em><span style="font-size: 14px;color: #aeaeae;">(2024-04-15)</span></span></p>
            <p id="cena_bez_rabatu" v-if="rabat > 0">Cena netto bez rabatu: <span>{{outputs.cena.total}} PLN</span></p>
            <div class="form-group">
              <label for="exampleFormControlFile1">Rabat [%]</label>
              <input class="form-control form-control-sm" v-model="rabat" type="number" placeholder="" min=0 max=99 @change="addRabat" />
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- <Results/> -->

    <Podsumowanie
      :showDialog="showDialogPodsumowanie"
      @clickedClose="closedDialog"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { calculation } from '../mixins/calculation'

import Bosch from '../assets/json/bosch'
import Pulsar from '../assets/json/pulsar'
import Szafy from '../assets/json/szafy'
import Akumulatory from '../assets/json/akumulatory'
import Materialy from '../assets/json/materialy'

import Header from './Header.vue'
import Urzadzenia from './Urzadzenia'
import Wizualizacja from './Wizualizacja'
import Results from './Results'
import DaneWejsciowe from './DaneWejsciowe'
import Akcesoria from './Akcesoria'
import Information from './Information.vue'
import Podsumowanie from './Dialogs/Podsumowanie.vue'

export default {
  name: 'Content',
  mixins: [app, calculation],
  data () {
    return {
      produkty_Bosch: Bosch,
      produkty_Pulsar: Pulsar,
      produkty_szafy: Szafy,
      produkty_akumulatory: Akumulatory,
      materialy: Materialy,
      tab: 'dane',
      rabat: 0,
      showDialogPodsumowanie: false
    }
  },
  watch: {
    'openFile' (newValue, oldValue) {
      this.changeValueRabat()
    }
  },
  computed: {
    ...mapGetters('app', ['dialogInfo']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['openFile']),
    cenaSystemuDSO () {
      // console.log('---- wycena ----')
      // console.log('szafa: ', Number(this.outputs.cena.szafa))
      // console.log('akumulatory: ', Number(this.outputs.cena.akumulatory))
      // console.log('listwaD: ', Number(this.outputs.cena.listwaD))
      // console.log('listwaZ: ', Number(this.outputs.cena.listwaZ))
      // console.log('panelS: ', Number(this.outputs.cena.panelS))
      // console.log('panelW: ', Number(this.outputs.cena.panelW))
      // console.log('polka: ', Number(this.outputs.cena.polka))
      // console.log('inne: ', Number(this.outputs.cena.inne))
      return Number(this.outputs.cena.szafa) + Number(this.outputs.cena.akumulatory) + Number(this.outputs.cena.listwaD) + Number(this.outputs.cena.listwaZ) + Number(this.outputs.cena.panelS) + Number(this.outputs.cena.panelW) + Number(this.outputs.cena.polka) + Number(this.outputs.cena.inne)
    },
    cenaPozostalychElementow () {
      return Number(this.cena_rabat_sztuka(Number(this.outputs.cena.obudowa_plytki) + Number(this.outputs.cena.obudowa_dsos24) + Number(this.outputs.cena.zasilacz_dsos24_pra))) + Number(this.outputs.cena.kolka)
    },
    cena () {
      // console.log('---- SUMA ----')
      // console.log('cenaSystemuDSO: ', Number(this.cenaSystemuDSO))
      // console.log('cenaSystemuDSO rabat: ', Number(this.cena_rabat_sztuka(this.cenaSystemuDSO)))
      // console.log('pozostale: ', Number(this.cenaPozostalychElementow))
      // console.log('suma: ', Number(this.cena_rabat_sztuka(this.cenaSystemuDSO)) + Number(this.cenaPozostalychElementow))
      return Number(this.cena_rabat_sztuka(this.cenaSystemuDSO)) + Number(this.cenaPozostalychElementow)
      // return (this.outputs.cena.total - this.outputs.cena.kolka) - ((this.outputs.cena.total - this.outputs.cena.kolka) * (this.rabat / 100)) + this.outputs.cena.kolka
    },
    rabatValue () {
      if (this.openFile) {
        return this.outputs.rabat.value
      } else {
        return this.rabat
      }
    }
  },
  components: {
    Header,
    Urzadzenia,
    Wizualizacja,
    Results,
    DaneWejsciowe,
    Akcesoria,
    Information,
    Podsumowanie
  },
  methods: {
    get_bosch () {
      this.$store.commit('products/SET_LIST_BOSCH', this.produkty_Bosch)
    },
    get_pulsar () {
      this.$store.commit('products/SET_LIST_PULSAR', this.produkty_Pulsar)
    },
    get_szafy () {
      this.$store.commit('products/SET_LIST_SZAFY', this.produkty_szafy)
      this.changeValueOutputs('szafa', 'array', this.produkty_szafy[0])
    },
    get_akumulatory () {
      this.$store.commit('products/SET_LIST_AKUMULATORY', this.produkty_akumulatory)
    },
    get_materialy () {
      this.$store.commit('products/SET_LIST_MATERIALY', this.materialy)
    },
    changeTab (evt) {
      this.tab = evt
    },
    addRabat () {
      this.changeValueOutputs('rabat', 'value', this.rabat)
    },
    closedDialog (bool) {
      this.showDialogPodsumowanie = bool
    },
    cena_rabat_sztuka (cena) {
      // console.log(cena)
      return parseFloat(cena - (cena * (this.outputs.rabat.value / 100))).toFixed(2)
    },
    changeValueRabat () {
      this.rabat = Number(this.outputs.rabat.value)
    }
  },
  created () {
    this.get_bosch()
    this.get_pulsar()
    this.get_szafy()
    this.get_akumulatory()
    this.get_materialy()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#Content {
  background: #efefef;
}
.container {
  width: 100%;
  max-width: 1200px;
}
.row {
  margin-top: 15px;
  min-height: 680px;
  position: absolute;
}
.topInfo {
width: 100%;
padding: 4px;
background: #fff;
text-align: left;
color: red;
position: fixed;
z-index: 2;
top: 80px;
}
.topInfo button {
  background: none;
  border:none;
  color: red;
  cursor: pointer;
}
.dialogInfo {
  width: 100%;
  padding: 10px;
  background: #fff;
  text-align: center;
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.dialogInfo svg{
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.dialogInfo button{
  background: none;
  border:none;
  color: red;
  cursor: pointer;
  float:right
}
button {
  background: none;
  border: none;
  text-align: left;
  color: rgb(174, 174, 174);
  cursor: pointer;
}
.active {
  color: white;
}
h4 {
  height: 28px;
}
h4 div {
  width: 50%;
  float:left
}
#kreska {
height: 38px;
width: 4px;
background: white;
-webkit-transform: rotateZ(33deg);
transform: rotateZ(33deg);
position: absolute;
top: 6px;
left: 45%;
}
.md-list-item {
background: #36b9fd;
margin-bottom: 2px;
}
.md-list-item .md-list-item-text {
color: white;
font-weight: bold;
}
.md-list-item-expand {
  border: none
}
.iconClear {
border: medium none;
color: white;
cursor: pointer;
position: absolute;
left: 720px;
background: white;
box-shadow: rgb(209, 209, 209) 3px 3px 0px;
z-index: 2;
width: 40px;
height: 40px;
padding: 0px;
text-align: center;
top:60px
}
.nr-konfiguracji {
border: medium none;
color: rgb(0, 0, 0);
position: absolute;
left: 720px;
background: white;
box-shadow: rgb(209, 209, 209) 3px 3px 0px;
z-index: 2;
width: 380px;
height: 40px;
padding: 0px;
text-align: left;
font-size: 18px;
line-height: 36px;
}
.imgClear {
  width: 30px;opacity: 0.7;
}
#panelCena {
width: 380px;
margin-top: 10px;
background: white none repeat scroll 0% 0%;
box-shadow: rgb(209, 209, 209) 3px 3px 0px;
padding: 1px;
margin-left: -15px;
}
#panelCena p {
margin-left: 4px;
text-align: left;
padding: 4px 4px;
font-size: 18px;
margin-bottom: 0px;
}
#panelCena p#cena_netto span {
color: rgb(53, 192, 11);
font-weight: normal;
font-size: 29px;
position: absolute;
margin-left: 10px;
font-style: italic;
}
#panelCena p#cena_bez_rabatu {
font-size: 14px;
}
#panelCena p#cena_bez_rabatu span {
font-weight: normal;
font-size: 14px;
position: absolute;
margin-left: 10px;
font-style: italic;
}
#panelCena .form-group {
  margin-left: 10px;
}
#panelCena .form-group input {
width: 70px;
margin-left: 10px;
}
.btnResult {
background: #5096c7;
color: white;
margin-right: 10px;
}

#info-place {
  width: 560px;
  text-align: left;
  font-weight: bold;
  line-height: 15px;
  margin: 0px auto;
  margin-top: 40px;
}
#info-place ul {
  border: 2px solid #ff0303;
padding: 15px;
list-style-type: disclosure-closed;
}

#info-place ul li{
display: list-item;
}
</style>



// WEBPACK FOOTER //
// src/components/Content.vue